var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "创建盘点",
        visible: true,
        "before-close": _vm.onCloseDialog,
        width: "800px"
      }
    },
    [
      _c(
        "el-form",
        [
          _c(
            "el-form-item",
            { attrs: { label: "盘点类型" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "250px" },
                  attrs: { placeholder: "盘点类型", filterable: "" },
                  model: {
                    value: _vm.form.inventory_type,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "inventory_type", $$v)
                    },
                    expression: "form.inventory_type"
                  }
                },
                _vm._l(_vm.resData.inventory_type, function(item) {
                  return _c("el-option", {
                    key: item.key,
                    attrs: { label: item.label, value: item.key }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "盘点方式" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "250px" },
                  attrs: { placeholder: "盘点方式", filterable: "" },
                  model: {
                    value: _vm.form.inventory_model,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "inventory_model", $$v)
                    },
                    expression: "form.inventory_model"
                  }
                },
                _vm._l(_vm.resData.inventory_model, function(item) {
                  return _c("el-option", {
                    key: item.key,
                    attrs: { label: item.label, value: item.key }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "盘点仓区" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "250px" },
                  attrs: { placeholder: "盘点仓区", filterable: "" },
                  model: {
                    value: _vm.form.area_type,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "area_type", $$v)
                    },
                    expression: "form.area_type"
                  }
                },
                _vm._l(_vm.resData.area_type, function(item) {
                  return _c("el-option", {
                    key: item.key,
                    attrs: { label: item.label, value: item.key }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticStyle: { width: "150px" },
                  attrs: {
                    placeholder: "盘点仓区",
                    filterable: "",
                    multiple: ""
                  },
                  on: { change: _vm.getTunnels },
                  model: {
                    value: _vm.form.areas,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "areas", $$v)
                    },
                    expression: "form.areas"
                  }
                },
                _vm._l(_vm.resData.areas, function(item) {
                  return _c("el-option", {
                    key: item,
                    attrs: { label: item, value: item }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  attrs: { placeholder: "盘点仓位", filterable: "" },
                  model: {
                    value: _vm.form.space_type,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "space_type", $$v)
                    },
                    expression: "form.space_type"
                  }
                },
                _vm._l(_vm.resData.inventory_space_type, function(item) {
                  return _c("el-option", {
                    key: item.key,
                    attrs: { label: item.label, value: item.key }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "盘点巷道" } },
            _vm._l(_vm.tunnels, function(tunnel, key) {
              return _c(
                "el-row",
                {
                  key: key,
                  staticStyle: { "margin-left": "80px", "margin-top": "10px" },
                  attrs: { type: "flex" }
                },
                [
                  _c("el-col", { attrs: { span: 1 } }, [
                    _vm._v(_vm._s(tunnel.area) + ":")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { size: "small" },
                          model: {
                            value: _vm.form.tunnels[key].min,
                            callback: function($$v) {
                              _vm.$set(_vm.form.tunnels[key], "min", $$v)
                            },
                            expression: "form.tunnels[key].min"
                          }
                        },
                        _vm._l(tunnel.tunnels, function(value, value_key) {
                          return _c("el-option", {
                            key: value_key,
                            attrs: { value: value, label: value }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticStyle: { "margin-left": "15px" },
                      attrs: { span: 1 }
                    },
                    [_vm._v("至")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { size: "small" },
                          model: {
                            value: _vm.form.tunnels[key].max,
                            callback: function($$v) {
                              _vm.$set(_vm.form.tunnels[key], "max", $$v)
                            },
                            expression: "form.tunnels[key].max"
                          }
                        },
                        _vm._l(tunnel.tunnels, function(value, value_key) {
                          return _c("el-option", {
                            key: value_key,
                            attrs: { value: value, label: value }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "备注说明" } },
            [
              _c("el-input", {
                attrs: { placeholder: "remark" },
                model: {
                  value: _vm.form.remark,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "remark", $$v)
                  },
                  expression: "form.remark"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.onCloseDialog } }, [
            _vm._v("取 消")
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.createInventory } },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35818684", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35818684","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/inventory/components/CreateInventory.vue
// module id = null
// module chunks = 